class SentMessageBookmarks {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/sent-message-bookmarks`;
    this.apiClient = apiClient;

  }

  async createSentMessageBookmark(sentMessageBookmark) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, sentMessageBookmark);

  }

  async getSentMessageBookmarks(queryOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async markSentMessageBookmarkAsUsed(sentMessageBookmarkId) {

    const path = `${this.basePath}/:sentMessageBookmarkId/used`;

    return this.apiClient.put(path, { sentMessageBookmarkId }, {}, {});

  }

  async deleteSentMessageBookmark(sentMessageBookmarkId) {

    const path = `${this.basePath}/:sentMessageBookmarkId`;

    return this.apiClient.delete(path, { sentMessageBookmarkId }, {});

  }

}

export default SentMessageBookmarks;